<template>
  <el-dialog
    v-model="dialogVisible"
    width="500px"
    :before-close="handleClose"
    
  >
    <div class="login-title flex">
      <!-- <el-icon class="el-input__icon" :size="30"><Monitor /></el-icon> -->
      <span>用户登录</span>
    </div>
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      status-icon
      :rules="rules"
      
      label-width="0"
      class="login-ruleForm"
    >
      <el-form-item label="" prop="userName">
        <el-input 
          v-model.number="ruleForm.userName" 
          placeholder="手机号码"
          size="large"
          class="login-ipt"
        >
          <template #prefix>
            <el-icon class="el-input__icon" :size="20"><User /></el-icon>
          </template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="" prop="passWord">
        <el-input
          v-model="ruleForm.passWord"
          type="password"
       
          placeholder="密码"
          size="large"
          class="login-ipt"
        >
          <template #prefix>
            <el-icon class="el-input__icon" :size="20"><Lock /></el-icon>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="sum">
        <el-input 
          v-model.number="ruleForm.sum" 
          :placeholder="`请计算 ${number1} + ${number2}`"
          size="large"
          class="login-ipt"
        >
          <template #prefix>
            <el-icon class="el-input__icon" :size="20"><Connection /></el-icon>
          </template>
        </el-input>
      </el-form-item>
      <div class="tools flex">
        <div class="forgot" @click="backPass()">忘记密码？</div>
        <div class="register" @click="register()">注册</div>
      </div>
      
      <el-button type="primary" @click="submitForm(ruleFormRef)" size="large" class="login-btn">登录</el-button>
      <div style="height: 30px"></div>
    </el-form>
   
  </el-dialog>
</template>

<script>
import { useStore } from "vuex"
import { api } from "@/api"
import { ElMessageBox, ElMessage } from 'element-plus'
import { ref, reactive, toRefs, getCurrentInstance } from 'vue'
// import { phone_reg } from "@/tools"
import { User, Lock, Monitor, Connection } from '@element-plus/icons-vue'
import { useRouter } from "vue-router"

export default {
  name:'userLogin',
  components: {User, Lock, Monitor, Connection},
  setup() {
    const { proxy } = getCurrentInstance()
    let store = useStore()
    let router = useRouter()
    const initData = reactive({
      dialogVisible: false,
      ruleForm: {
        // userName: "18380473185",
        // passWord: "123456",
        userName: "",
        passWord: "",
        sum: ""
      },
      rules: {
        userName: [{ validator: validateName, trigger: 'blur' }],
        passWord: [{ validator: validatePass, trigger: 'blur' }],
        sum: [{ validator: validateSum, trigger: 'blur' }],
      },
      number1: rand(10, 1),
      number2: rand(10, 1),

    })
    const ruleFormRef = ref(null)
    // 打开登录
    proxy.$mitt.on("showLogin", message => {
      initData.dialogVisible = true
    });
    // 验证用户名
    function validateName (rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写用户名'))
      }
      callback()
      
    }
    // 验证密码
    function validatePass (rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写密码'))
      }
      callback()
    }
    // 验证求和
    function validateSum (rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写计算结果'))
      }
      if(value === initData.number1 + initData.number2) {
        callback()
      } else {
        return callback(new Error('请填写计算有误'))
      }
      
    }
    // 点击登录按钮
    const submitForm = (formEl) => {
      if (!formEl) return
      formEl.validate((valid) => {
        if (valid) {
          login()
        } else {
          console.log('error submit!')
          return false
        }
      })
    }

    // 用户登录
    function login() {
      api("post", "login", {username: initData.ruleForm.userName, password: initData.ruleForm.passWord}).then(res => {
        if(res.code === 1200) {
          store.commit("setUserInfo", res.data)
          localStorage.setItem("whgUserInfo", JSON.stringify(res.data))
          ElMessage({
            message: '登录成功',
            type: 'success',
          })
          initData.dialogVisible = false
        } else {
          ElMessageBox.alert("账号或密码有误", {
            confirmButtonText: 'OK',
            callback: () => {
              
            },
          })
        }
      })
      .catch(err => {
        ElMessageBox.alert("遇到一些意料之外的错误请刷新网页重试", {
          confirmButtonText: 'OK',
          callback: () => {
            
          },
        })
      })
    }
    // 关闭登录弹窗
    const handleClose = () => {
      initData.dialogVisible = false
    }
    // 获取随机数
    function rand(x, y) {
      return parseInt(Math.random() * (x - y + 1) + y);
    }
    function register() {
      initData.dialogVisible = false
      router.push({
        path: "/register"
      })
    }
    function backPass() {
      router.push({
        path: "/backpass"
      })
    }
    return {
      ...toRefs(initData),
      submitForm,
      ruleFormRef,
      handleClose,
      register,
      backPass
    }
  }
}
</script>
<style lang='less' scoped>

.login-title {
  align-items: center;
  justify-content: center;
  position: relative;
  top: -25px;
  span {
    font-size: 22px;
    font-weight: bold;
    margin-left: 10px;
  }
}
.login-ruleForm {
  width: 350px;
  margin: 0 auto;
  :deep(.el-input__inner) {
    font-size: 16px;
    padding-left: 40px;
    
  }
  .tools {
    justify-content: space-between;
    .forgot,.register {
      margin-top: 10px;
      font-size: 12px;
      color: #aaa;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #66b1ff;
      }
    }
  }
  
  .login-btn {
    width: 350px;
    margin-top: 15px;
    color: #fff;
  }
}

</style>
